import { render, staticRenderFns } from "./badgealert.vue?vue&type=template&id=14bfac25&"
import script from "./badgealert.vue?vue&type=script&lang=js&"
export * from "./badgealert.vue?vue&type=script&lang=js&"
import style0 from "./badgealert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports